// vendor modules
import React from "react"
import PropTypes from "prop-types"

import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { useTruncated } from "app/static/frontend/imports/hooks"

// components
import { SelectBooleanTriplet } from "quorumdesign"

const BooleanFilter = (props) => {
    const [truncationRef, isTruncated] = useTruncated()

    const toggle = (value) => () => {
        if (props.deserializedValue === value && !props.isNullable) {
            return
        }

        const newValue = props.deserializedValue === value ? undefined : value

        return props.publishChange(newValue)
    }

    const renderButton = (onClick, text, activeValue) => {
        const extraClass = props.deserializedValue === activeValue ? "picked" : ""

        return (
            <OverlayTrigger
                trigger={["hover", "focus"]}
                key={`boolean-filter-overlaytrigger-${text}`}
                placement="right"
                overlay={
                    isTruncated ? (
                        <Tooltip key={`boolean-filter-tooltip-${text}`} id={text}>
                            {text}
                        </Tooltip>
                    ) : (
                        <div />
                    )
                }
            >
                {/* ignoring jsx-a11y rules to apply other style changes to the file - should be updated to enforce accessibility */}
                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
                <div className={`btn bitwise-button ${extraClass}`} key={text} onClick={onClick} ref={truncationRef}>
                    {text}
                </div>
            </OverlayTrigger>
        )
    }

    let isHorizontal = false

    if (props.trueText === "Yes" || props.trueText === "ANY") {
        isHorizontal = true
    }

    if (
        props.searchFilterTerm &&
        [(props.falseText || "").toString().toLowerCase(), (props.trueText || "").toString().toLowerCase()].some(
            (text) => text.includes(props.searchFilterTerm.toLowerCase()),
        )
    ) {
        if (props.setFilterGroupContainsSearchFilterTerm) {
            props.setFilterGroupContainsSearchFilterTerm(true)
        } else {
            // not marked required
            console.error(
                `Missing props.setFilterGroupContainsSearchFilterTerm — ${props.searchFilterTerm} contained in "${props.falseText}, ${props.trueText}".`,
            )
        }
        if (props.setFilterContainsSearchFilterTerm) {
            props.setFilterContainsSearchFilterTerm(true)
        } else {
            // not marked required
            console.error(
                `Missing props.setFilterContainsSearchFilterTerm — ${props.searchFilterTerm} contained in "${props.falseText}, ${props.trueText}".`,
            )
        }
    }

    return (
        <SelectBooleanTriplet
            deserializedValue={props.deserializedValue}
            falseText={props.falseText}
            inverted={props.inverted}
            isHorizontal={isHorizontal}
            isNullable={props.isNullable}
            publishChange={props.publishChange}
            searchFilterTerm={props.searchFilterTerm}
            trueText={props.trueText}
        />
    )
}

BooleanFilter.propTypes = {
    publishChange: PropTypes.func.isRequired,
    deserializedValue: PropTypes.bool,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
    inverted: PropTypes.bool,
    helpText: PropTypes.string,
    isNullable: PropTypes.bool,
    // selected from the search => props.uniqueFlvId slice of the store
    searchFilterTerm: PropTypes.string,
    // from app/static/frontend/search-new/components/Filter/index.js
    setFilterContainsSearchFilterTerm: PropTypes.func,
    // from app/static/frontend/search-new/components/FilterGroup/index.js renderFilters
    setFilterGroupContainsSearchFilterTerm: PropTypes.func,
}

BooleanFilter.defaultProps = {
    trueText: "True",
    falseText: "False",
    isNullable: true,
}

export default BooleanFilter
